import React from 'react';

import classNames from 'classnames';

export default function Table({
  blankState,
  headers,
  rows,
  tableClassName,
  tbodyClassName,
}) {
  return (
    <>
      <table
        className={classNames(
          'table handshq__table handshq__table--spaced handshq__table--middled tw-border-grey-100 tw-bg-white',
          tableClassName,
        )}
      >
        <thead className='handshq__thead tw-border-grey-100 tw-bg-grey-050'>
          {headers}
        </thead>
        <tbody
          className={classNames(
            'handshq__tbody tw-border-grey-100',
            tbodyClassName,
          )}
        >
          {rows}
        </tbody>
      </table>
      {rows.length === 0 && blankState}
    </>
  );
}

Table.defaultProps = {
  tableClassName: '',
  tbodyClassName: '',
};
